__webpack_require__.p = "/reports-ngrx/onboarding/";